import { ajaxPostAnon, ajaxPostFormAnon } from './AjaxHelper.js';
declare var $;
declare var Cookies;

export function postLoginExtranet(siteNam, sitePwd, isToken, callback) {
    var data = {
        'grant_type': 'password',
        'username': siteNam,
        'password': sitePwd,
        'scope': 'extranet' + (isToken ? ' token' : '')
    }

    ajaxPostFormAnon("/api/token", data, (newData, ok) => {
        if (ok) { 
            Cookies.set("namezzz", newData.access_token, { expires: 1.5/24 });
            Cookies.set("userType", "extranet", { expires: 1.5/24 });
        }

        callback(ok);
    });
}

export function postLogin(siteNam, sitePwd, callback) {
    var data = {
        'grant_type': 'password',
        'username': siteNam,
        'password': sitePwd
    }

    ajaxPostFormAnon("/api/token", data, (newData, ok) => {
        if (ok) { 
            Cookies.set("namezzz", newData.access_token, { expires: 1.5/24 });
            Cookies.set("userType", "member", { expires: 1.5/24 });
            $("body").addClass("SnsAuthenticated");
        }

        callback(ok);
    });
}

export function postRegister(name, firstName, birthday, sex, email, password, languageId, callback) {
    var data = {
        nam: name,
        firstNam: firstName,
        gebDatum: birthday,
        sex: sex,
        siteNam: email,
        sitePwd1: password,
        sitePwd2: password,
        email: email,
        seqLangFill: languageId,
        sessionId: "webapi"
    }

    ajaxPostAnon("/api/register", data, (newData, ok) => {
        callback(newData, ok);
    });
}


// WEBPACK FOOTER //
// ./src/Api/Register.js